"use client";

import "./style.css";
import { useState } from "react";
import { CaretDownIcon, CaretUpIcon } from "@phosphor-icons/react";
import { HTMLContentServer } from "./HTMLContentServer";

interface HTMLContentProps {
  html: TrustedHTML;
  className?: string;
  readMore?: boolean;
}

export default function HTMLContent({
  html,
  className,
  readMore = false,
}: HTMLContentProps) {
  const [open, setOpen] = useState(false);

  // If no readMore functionality is needed, use server component for SEO
  if (!readMore) {
    return <HTMLContentServer html={html} className={className} />;
  }

  // For readMore functionality, render server component with toggle button
  return (
    <div className="relative">
      <HTMLContentServer 
        html={html} 
        className={className} 
        truncated={!open}
      />
      {/* Gradient overlay when truncated */}
      {!open && (
        <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white via-white/80 to-transparent pointer-events-none" />
      )}
      {/* Read more button */}
      <div className="relative -mt-4 pb-2 flex justify-center">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-primary-600 hover:text-primary-700 bg-white hover:bg-primary-50 border border-primary-200 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md z-10 cursor-pointer"
        >
          {open ? (
            <>
              <span>مشاهده کمتر</span>
              <CaretUpIcon className="w-4 h-4" weight="bold" />
            </>
          ) : (
            <>
              <span>مشاهده بیشتر</span>
              <CaretDownIcon className="w-4 h-4" weight="bold" />
            </>
          )}
        </button>
      </div>
    </div>
  );
}
